const url = {
  dev: {
    // 本地调试ip
    publicUrl: '/baseUrl',
    manageUrl: '/baseUrl',
  },
  pro: {
    // 正式服
    publicUrl: `https://www.nuoyayunpingtai.com/nyy`,
    manageUrl: `https://www.nuoyayunpingtai.com/nyy`,
    // publicUrl: `https://test.nuoyayunpingtai.com/nyy`,
    // manageUrl: `https://test.nuoyayunpingtai.com/nyy`,
  },
  pro_test: {
    // 测试服
    publicUrl: `https://test.nuoyayunpingtai.com/nyy`,
    manageUrl: `https://test.nuoyayunpingtai.com/nyy`,
  },
}

export const get = () => {
  console.log(process.env.NODE_ENV, 999)
  if (process.env.NODE_ENV === 'production') {
    return url['pro']
  } else if (process.env.NODE_ENV === 'test') {
    return url['pro_test']
  } else {
    return url['dev']
  }
}
